import { ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useAuthSync } from './hooks/useAuthSync';
import {
    AppBar
} from './lib';
import { AssistentButton } from './lib/components/complex/AssistentButton';
import { StreamFinIcon } from './lib/icons';
import { customTheme } from './lib/styles/theme';
import { AdvisorDashboard } from './pages/AdivisorDashboard';
import { Login } from './pages/Login';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { useDrawerStore } from './store/drawerStore';
import { AppSnackbar } from './lib/components/complex/Snackbar';

function App() {
    const open = useDrawerStore((s: any) => s.open);
    const isFullscreen = useDrawerStore((s: any) => s.isFullscreen);
    const toggle = useDrawerStore((s: any) => s.toggle);
    useAuthSync();
    return (
        <ThemeProvider theme={customTheme}>
            <BrowserRouter>
                <Routes>
                    {/* Página aberta */}
                    <Route path="/login" element={<Login />} />

                    {/* Página protegida */}
                    <Route 
                        path="/" 
                        element={
                            <ProtectedRoute>
                                <>
                                    <AppBar open={open && !isFullscreen} icon={<StreamFinIcon />} brandName="StreamFin">
                                        {!open && <AssistentButton onClick={toggle} />}
                                    </AppBar>
                                    <AdvisorDashboard />
                                </>
                            </ProtectedRoute>
                        } 
                    />
                </Routes>
                <AppSnackbar/>
            </BrowserRouter>
        </ThemeProvider>
    )
}

export default App